/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GameTag {
    CASUAL = 'casual',
    CHESS = 'chess',
    PUZZLE = 'puzzle',
}
